<template>
  <dialog class="m-dialog">
    <div @click="$emit('cancel')" class="dialog-overlay"></div>
    <div class="dialog-contents">
      <div class="dialog-text">
        <h2 v-if="title">{{ title }}</h2>
        <slot></slot>
      </div>
      <div v-if="buttons" class="buttons">
        <Button @click="$emit('ok')">{{ okText || "OK" }}</Button>
        <Button @click="$emit('cancel')">Cancel</Button>
      </div>
      <Button v-else class="close-button" @click="$emit('cancel')">
        X
      </Button>
    </div>
  </dialog>
</template>

<script>
export default {
  name: "Dialog",
  components: {},
  data() {
    return {};
  },
  methods: {},
  props: {
    title: String,
    buttons: Boolean,
    okText: String
  },
  mounted() {
    window.addEventListener("keyup", ev => {
      if (ev.key === "Escape") {
        this.$emit("cancel");
      }
    });
  }
};
</script>

<style scoped>
dialog {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  background-color: transparent;
}
.dialog-overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.7;
}
.dialog-contents {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: auto;
  background-color: #fff;
  padding: 20px;
  overflow-y: auto;
  min-width: 320px;
  max-width: 90%;
  max-height: 90%;
}
.buttons {
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  margin-top: 20px;
}
button {
  margin-left: 5px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
